var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M6 7.4L.6 2 2 .6l4 4 4-4L11.4 2 6 7.4z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }